const AGENCY_PROFILE_PREFIX = '/real-estate-agencies/';

const buildAgencyProfileUrl = (
  agencyUrlPath?: string | null,
  agencyId?: number | null,
): string | null => {
  const agencyPath = agencyUrlPath ?? agencyId?.toString();
  if (!agencyPath) {
    return null;
  }

  const normalizedPath = agencyPath.startsWith('/')
    ? agencyPath
    : `/${agencyPath}`;
  const agencyUrl = normalizedPath.startsWith(AGENCY_PROFILE_PREFIX)
    ? normalizedPath
    : `/real-estate-agencies${normalizedPath}`;

  return agencyUrl.endsWith('/') ? agencyUrl : `${agencyUrl}/`;
};

export default buildAgencyProfileUrl;
